<template>
    <ui-crud title="Supplier Quotes" subtitle="A list of supplier quotes for this package"
             :fetch="fetch" :pipe-with="pipeItems" ref="crud">

        <template v-slot:new-button>
            <div class="flex items-center">
                <h1 v-text="'Supplier Quotes'" class="text-lg font-medium text-gray-900"></h1>
                <div v-if="supplierQuoteClipboard.length === 0" class="ml-auto hidden sm:inline-flex">
                    <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                   @click.prevent="createNew()">New
                    </ui-button-new>
                </div>
                <div v-else class="ml-auto hidden sm:inline-flex">
                    <ui-dropdown placement="bottom-end" class="ml-auto" menu-class="p-3 w-64 z-[60]" :key="userKey">
                        <template #default="{ toggle }">
                            <ui-button-new @click="toggle" small class="ml-auto hidden sm:inline-flex">
                                <i class="text-gray-400 flex-shrink-0 mr-2 fa fa-chevron-down"></i>
                                New
                            </ui-button-new>
                        </template>
                        <template #menu="{ close }">
                            <ui-dropdown-item icon="fas fa-print" @click="createNew();close();">Create new Supplier
                                Quote
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fas fa-paste"
                                              @click="pasteSupplierQuote();close();">
                                Paste as New Supplier Quote
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </div>
            </div>
            <p v-text="'A list of supplier quotes for this package.'" class="mt-1 text-sm text-gray-600"></p>
            <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus"
                           @click.prevent="createNew()">New
            </ui-button-new>
        </template>

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>


        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.supplierName}`"
                :subtitle="'Valid '+(item.validFrom?('from '+item.validFrom+(item.validTo?' to '+item.validTo:'')):(item.validFrom?'':(item.validTo?'until ':'')+(item.validTo?item.validTo:'')))"
                :metadata="`${item.createdBy}`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <supplier-quotes-form :store="store"
                                  :package-reference="packageReference"
                                  :add-item="addItem">
            </supplier-quotes-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ addItem, selectedItem, setEditMode }">
            <supplier-quotes-form :store="store"
                                  :package-reference="packageReference"
                                  :add-item="addItem"
                                  :item="selectedItem"
                                  :edit="setEditMode">
            </supplier-quotes-form>
        </template>
        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <supplier-quotes-show :store="store"
                                  :package-reference="packageReference"
                                  :add-item="addItem"
                                  :removeItem="removeItem"
                                  :item="selectedItem"
                                  :edit="setEditMode">
            </supplier-quotes-show>

        </template>
    </ui-crud>
</template>

<script>
import {CompanyNew, MaterialNew, SupplierQuote} from "@models";
import UiDropdown from "../ui/UiDropdown.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiDropdownDivider from "../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import remoteStorage from "../../utils/remoteStorage";
import {isNull} from "lodash";
import User from "../../services/User";

export default {
    components: {UiDropdownItem, UiDropdownDivider, UiButtonNew, UiDropdown},
    props: {
        packageReference: Number,
        admin: Boolean,
    },
    data() {
        return {
            search: '',
            store: {
                companies: [],
                materials: [],
                loaded: false
            },
            supplierQuoteClipboard: [],
            user: {},
            userKey: 0,
        }
    },
    watch: {
        userClipboardToBeWatched: {
            handler(newValue, oldValue) {
                this.supplierQuoteClipboard = remoteStorage.getItem('supplier-quote-clipboard') ? JSON.parse(remoteStorage.getItem('supplier-quote-clipboard')) : []
                this.userKey++;
            },
        },
    },
    computed: {
        userClipboardToBeWatched() {
            return this.user.remoteStorage ? this.user.remoteStorage['supplier-quote-clipboard'] : '';
        },
    },
    methods: {
        isNull,
        async fetch() {
            return await SupplierQuote.all(this.packageReference)
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((route) => {
                    return query.every((token) => {
                        return route.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        async pasteSupplierQuote() {
            let data = this.supplierQuoteClipboard[0];
            const sq = await SupplierQuote.create(this.packageReference, data);

            this.$refs.crud.addItem(sq, 0, (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            });
            this.$refs.crud.selectItem(sq);
            this.$refs.crud.setEditMode(true);
        },
        createNew() {
            this.$refs.crud.createNew()
        }
    },
    async mounted() {
        await User.register()
        this.user = User.user
        try {
            this.supplierQuoteClipboard = remoteStorage.getItem('supplier-quote-clipboard') ? JSON.parse(remoteStorage.getItem('supplier-quote-clipboard')) : []
        } catch (e) {
            //continue on JSON ERROR
        }
        this.store.companies = await CompanyNew.all()
        this.store.materials = await MaterialNew.all()
        this.store.loaded = true;
    }
}
</script>
